exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-input-container{width:100%;}\n.outer_width{width: 1000px;}\n.other_info .mat-error.error_text{font-size: 11px; position: relative; bottom: 6px; left: 0px;}\n.mat-checkbox{margin-right: 30px;}\n\n.date_pick .mydp .selection{border-radius: 0px; padding-left: 0px;}\n.date_pick .mydp{border: none !important; border-radius: 0px !important; border-bottom:1px solid rgba(0,0,0,.42) !important;}\n.outer_width{width: 700px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/trip-add-attendee/trip-add-attendee.component.css
// module id = ../../../../../src/app/admin/trip/trip-add-attendee/trip-add-attendee.component.css
// module chunks = 39